import React from 'react';
import { motion } from 'framer-motion';
import { Check, Minus, Clock, ShieldAlert } from 'lucide-react';
export function PricingSection() {
  const scrollToContact = () => {
    document.querySelector('#contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const features = [{
    name: 'Fotos ordenadas por obra',
    od: true,
    wa: false
  }, {
    name: 'Ubicación en plano por piso',
    od: true,
    wa: false
  }, {
    name: 'Timestamp verificable',
    od: true,
    wa: false
  }, {
    name: 'Autor identificable',
    od: true,
    wa: false
  }, {
    name: 'Búsqueda por fecha o keyword',
    od: true,
    wa: false
  }, {
    name: 'Historial permanente online',
    od: true,
    wa: false
  }, {
    name: 'Acceso web multi-dispositivo',
    od: true,
    wa: false
  }, {
    name: 'Respaldo ante conflictos',
    od: true,
    wa: false
  }, {
    name: 'Consolidación desde correo',
    od: true,
    wa: false
  }, {
    name: 'Sin capacitación ni apps nuevas',
    od: true,
    wa: true
  }];
  return <section id="precio" className="py-16 sm:py-24 bg-white" data-id="element-177">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-178">
        <div className="text-center mb-10 sm:mb-14" data-id="element-179">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-3" data-id="element-180">
            Precio simple y transparente
          </h2>
          <p className="text-base text-gray-500" data-id="element-181">Sin sorpresas.</p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} data-id="element-182">
          {/* Column Headers */}
          <div className="grid grid-cols-[1fr_88px_88px] sm:grid-cols-[1fr_120px_120px] mb-1" data-id="element-183">
            <div data-id="element-184" />
            <div className="text-center pb-4" data-id="element-185">
              <svg width="20" height="20" viewBox="0 0 40 40" fill="none" className="mx-auto mb-2" data-id="element-186">
                <rect x="8" y="20" width="14" height="14" rx="2.5" transform="rotate(-45 8 20)" fill="#BFDBFE" data-id="element-187" />
                <rect x="12" y="16" width="14" height="14" rx="2.5" transform="rotate(-45 12 16)" fill="#60A5FA" data-id="element-188" />
                <rect x="16" y="12" width="14" height="14" rx="2.5" transform="rotate(-45 16 12)" fill="#2563EB" data-id="element-189" />
              </svg>
              <div className="text-[11px] sm:text-xs font-semibold text-blue-600 mb-0.5" data-id="element-190">
                Obra Digital
              </div>
              <div className="text-sm sm:text-base font-bold text-gray-900" data-id="element-191">
                Desde UF 10
              </div>
              <div className="text-[10px] text-gray-400" data-id="element-192">al mes por obra</div>
            </div>
            <div className="text-center pb-4" data-id="element-193">
              <div className="w-5 h-5 mx-auto mb-2 rounded-full bg-[#25D366] flex items-center justify-center" data-id="element-194">
                <svg width="11" height="11" viewBox="0 0 24 24" fill="white" data-id="element-195">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" data-id="element-196" />
                </svg>
              </div>
              <div className="text-[11px] sm:text-xs font-semibold text-gray-500 mb-0.5" data-id="element-197">
                WhatsApp
              </div>
              <div className="text-sm sm:text-base font-bold text-gray-900" data-id="element-198">
              </div>
              <div className="text-[10px] text-gray-400" data-id="element-199">&nbsp;</div>
            </div>
          </div>

          {/* Divider */}
          <div className="h-px bg-gray-200" data-id="element-200" />

          {/* Feature Rows */}
          {features.map((feature, index) => <div key={index} data-id="element-201">
              <div className="grid grid-cols-[1fr_88px_88px] sm:grid-cols-[1fr_120px_120px] items-center py-3 sm:py-3.5" data-id="element-202">
                <span className="text-[13px] sm:text-sm text-gray-600 pr-4" data-id="element-203">
                  {feature.name}
                </span>
                <div className="flex justify-center" data-id="element-204">
                  {feature.od ? <Check className="w-4 h-4 text-blue-600" strokeWidth={2.5} data-id="element-205" /> : <Minus className="w-4 h-4 text-gray-300" strokeWidth={2} data-id="element-206" />}
                </div>
                <div className="flex justify-center" data-id="element-207">
                  {feature.wa ? <Check className="w-4 h-4 text-gray-400" strokeWidth={2.5} data-id="element-208" /> : <Minus className="w-4 h-4 text-gray-300" strokeWidth={2} data-id="element-209" />}
                </div>
              </div>
              {index < features.length - 1 && <div className="h-px bg-gray-100" data-id="element-210" />}
            </div>)}

          {/* Divider */}
          <div className="h-px bg-gray-200 mt-1" data-id="element-211" />

          {/* CTA */}
          <div className="pt-8 pb-2" data-id="element-212">
            <button onClick={scrollToContact} className="w-full py-3 px-6 rounded-xl text-sm sm:text-base font-semibold text-white bg-blue-600 hover:bg-blue-700 transition-colors" data-id="element-213">
              Probar en mi obra
            </button>
          </div>
        </motion.div>

        {/* Value arguments */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="mt-10 space-y-2" data-id="element-214">
          <div className="flex items-center justify-between py-3 px-4 rounded-lg bg-gray-50 text-[13px] sm:text-sm" data-id="element-215">
            <div className="flex items-center text-gray-600" data-id="element-216">
              <Clock className="w-3.5 h-3.5 mr-2 text-gray-400" data-id="element-217" />1 hora perdida
              buscando fotos
            </div>
            <span className="text-blue-600 font-semibold text-[13px] sm:text-sm" data-id="element-218">
              &gt; 1 mes de servicio
            </span>
          </div>
          <div className="flex items-center justify-between py-3 px-4 rounded-lg bg-gray-50 text-[13px] sm:text-sm" data-id="element-219">
            <div className="flex items-center text-gray-600" data-id="element-220">
              <ShieldAlert className="w-3.5 h-3.5 mr-2 text-gray-400" data-id="element-221" />1
              conflicto mal documentado
            </div>
            <span className="text-blue-600 font-semibold text-[13px] sm:text-sm" data-id="element-222">
              &gt; costo total del sistema
            </span>
          </div>
          <p className="text-xs text-gray-400 text-center pt-2" data-id="element-223">
            Menos del 0,1% del presupuesto total de una obra promedio.
          </p>
        </motion.div>
      </div>
    </section>;
}